import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';

export const fetchAcademy = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/academy_groups`,
    );

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      'Wystąpił problem pobierając grupy półkolonii. Odśwież aplikację.',
    );

    return [];
  }
};
